// extracted by mini-css-extract-plugin
export default {"primaryInfo":"styles-module__primaryInfo__src-labstep-web-screens-Group-Show-Settings-_FpKjr","card":"styles-module__card__src-labstep-web-screens-Group-Show-Settings-_CzOpC"};